import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  organisationEmailCheckAction,
  organisationSendInviteAction,
} from "../Redux/Action/OrganisationAction";
import { getActiveGroup } from "../OrganisationGroups/utils/roleAccess";

const InviteMemberOrganisationModal = ({ show, handleClose, onInviteSent }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isInviteLoading, setIsInviteLoading] = useState(false);
  const [checkedResult, setCheckedResult] = useState(null);

  const organisationGroupId = getActiveGroup(userData)?._id;
  const checkedPayload =
    checkedResult?.data || checkedResult?.payload?.data || {};
  const checkedType = checkedPayload?.type;
  const checkedMessage =
    checkedResult?.data?.message ||
    checkedPayload?.message ||
    checkedResult?.payload?.message ||
    "";
  const checkedSchool =
    checkedPayload?.school ||
    checkedPayload?.schoolData ||
    checkedPayload?.organisation ||
    checkedPayload?.memberOrganisation ||
    null;

  const canSendInvite =
    Boolean(checkedResult) &&
    (checkedType === "SCHOOL_SUPER_ADMIN" ||
      checkedType === "NON_SUPER_ADMIN") &&
    Boolean(email.trim()) &&
    Boolean(organisationGroupId);

  const handleSearch = async () => {
    if (!email.trim()) {
      setError("Please enter an email address.");
      return;
    }

    setError("");
    setCheckedResult(null);
    setIsLoading(true);
    const response = await dispatch(
      organisationEmailCheckAction({ email: email.trim() }),
    );
    if (response?.payload) {
      setCheckedResult(response.payload);
      if (response?.error) {
        setError(
          response?.payload?.message || "Unable to check this email right now.",
        );
      }
    } else {
      setError("Unable to check this email right now.");
    }
    setIsLoading(false);
  };

  const handleSendInvite = async () => {
    if (!canSendInvite) return;

    setError("");
    setIsInviteLoading(true);

    const invitePayload = {
      groupId: organisationGroupId,
      email:
        checkedType === "NON_SUPER_ADMIN"
          ? checkedPayload?.school?.schoolAccountOwnerEmail
          : checkedPayload?.email || email.trim(),
      inviteType: checkedType,
      schoolId: checkedSchool?._id,
    };

    const response = await dispatch(
      organisationSendInviteAction(invitePayload),
    );
    console.log("organisationSendInviteAction response", response?.payload);

    if (response?.error) {
      setError(
        response?.payload?.message || "Unable to send invite right now.",
      );
    } else {
      if (onInviteSent) {
        onInviteSent();
      }
      toast.success(
        response?.payload?.data?.message ||
          response?.payload?.message ||
          "Invitation email sent successfully",
        {
          duration: 3000,
        },
      );
      handleHide();
    }

    setIsInviteLoading(false);
  };

  const handleHide = () => {
    setEmail("");
    setError("");
    setCheckedResult(null);
    handleClose();
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleHide}
      className="comn-modal-set create"
      centered
    >
      <Modal.Header className="d-block" style={{ border: "0" }}>
        <Row>
          <Col lg={12} className="d-flex justify-content-center mb-4">
            <div>
              <Modal.Title className="p-0">
                Invite Member Organisation
              </Modal.Title>
              <p className="text-center mb-0">
                Search by email to invite an organisation
              </p>
            </div>
          </Col>
        </Row>
        <div className="modal-right">
          <button className="menu-dots" onClick={handleHide}>
            <img
              src={require("../Assets/Images/dotsweb.svg").default}
              alt="close"
            />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col lg={12}>
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                className="input-set"
                placeholder="Enter organisation email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError("");
                  setCheckedResult(null);
                }}
              />
              {error && <div className="error text-danger mt-1">{error}</div>}
            </Form.Group>
          </Col>
        </Row>
        {checkedResult && (
          <Row>
            <Col lg={12}>
              <div className="cmn-card-color p-3 mb-2">
                {checkedMessage && <p className="mb-2">{checkedMessage}</p>}

                {checkedSchool && (
                  <div>
                    <p className="mb-1">
                      <strong>School:</strong>{" "}
                      {checkedSchool?.schoolName ||
                        checkedSchool?.name ||
                        "N/A"}
                    </p>
                    {(checkedSchool?.schoolEmail ||
                      checkedPayload?.schoolEmail) && (
                      <p className="mb-1">
                        <strong>Super Admin Email:</strong>{" "}
                        {checkedSchool?.schoolEmail ||
                          checkedPayload?.schoolEmail}
                      </p>
                    )}
                    {checkedSchool?.address && (
                      <p className="mb-0">
                        <strong>Address:</strong> {checkedSchool.address}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer className="border-none justify-content-center">
        <Button
          variant="primary"
          className="modal-f-btn"
          onClick={handleSearch}
          disabled={isLoading}
        >
          {isLoading ? "Searching..." : "Search"}
        </Button>
        <Button
          variant="primary"
          className="modal-f-btn"
          onClick={handleSendInvite}
          disabled={
            !canSendInvite ||
            isInviteLoading ||
            checkedType === "NOT_REGISTERED" ||
            checkedType === "ORGANISATION"
          }
        >
          {isInviteLoading ? "Sending..." : "Send Invite"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InviteMemberOrganisationModal;
